<template>
  <div ref="row" class="d-flex overflow-auto flex-nowrap" @wheel.prevent="handleScroll">
    <slot />
  </div>
</template>

<script>
export default {
  name: "VerticalScroll",
  computed: {
    scrollLineHeight() {
      const el = document.createElement('div');
      el.style.fontSize = 'initial';
      el.style.display = 'none';
      document.body.appendChild(el);
      const fontSize = window.getComputedStyle(el).fontSize;
      document.body.removeChild(el);
      return fontSize ? window.parseInt(fontSize) : undefined;
    }
  },
  methods: {
    handleScroll(event) {
      let delta = event.deltaY;

      if (event.deltaMode === WheelEvent.DOM_DELTA_LINE) {
        delta *= this.scrollLineHeight;
      }

      this.$refs.row.scrollLeft += delta;
    },
  }
}
</script>